import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useAppDispatch, useAppSelector } from 'hooks/stateHooks';
import {
	setCountry,
	setL4Location,
	getL4SystemName,
	getAddress,
	getDescription,
	getCountry,
	getL4Location,
	setL4SystemName,
	setDescription,
	setAddress,
} from 'slices/l4SystemSlice';
import { getL4SystemIconsData } from 'slices/infoIconsDataSlice';
import { ICON_DESCRIPTION_ID } from 'utils/enum';

import CustomError from 'components/common/errorLabel/CustomError';
import CustomDropDown from 'components/common/forms/CustomDropdown';
import CustomInput from 'components/common/forms/CustomInput';
import CustomTextArea from 'components/common/forms/CustomTextArea';
import useGetAllCountry from 'components/tenant/hooks/useGetAllCountry';
import CustomEditableTooltip from 'components/common/tooltip/CustomEditableTooltip';

const CreateL4Config = ({ errorState, l4ById }: any) => {
	const { t } = useTranslation('l4System');
	const dispatch = useAppDispatch();
	const { dropdownCountryValues, loading } = useGetAllCountry();
	const l4SystemName = useAppSelector(getL4SystemName);
	const address = useAppSelector(getAddress);
	const description = useAppSelector(getDescription);
	const country = useAppSelector(getCountry);
	const l4Location = useAppSelector(getL4Location);
	const l4SystemIconsData = useAppSelector(getL4SystemIconsData);
	const [l4AddEditInfo, setL4AddEditInfo] = useState<string>('');

	// finds l3 add edit info from redux state
	useEffect(() => {
		// eslint-disable-next-line no-unused-expressions
		l4SystemIconsData?.length > 0 &&
			// eslint-disable-next-line array-callback-return
			l4SystemIconsData?.map((item: any) => {
				if (item?.encIconId === ICON_DESCRIPTION_ID.L4_ADD_EDIT) {
					setL4AddEditInfo(item?.iconDescription);
				}
			});
	}, [l4SystemIconsData]);

	const onL4SystemChange = (e: any) => {
		dispatch(setL4SystemName(e.target.value));
	};

	const onAddressChange = (e: any) => {
		dispatch(setAddress(e.target.value));
	};

	const onDescriptionChange = (e: any) => {
		dispatch(setDescription(e.target.value));
	};

	const onCountryChange = (e: any) => {
		dispatch(setCountry(e));
	};

	const onLocationChange = (e: any) => {
		dispatch(setL4Location(e.target.value));
	};

	return (
		<>
			<h4 className='form-section-title mb-3 info-title'>
				{l4ById !== 0 ? `${t('UPDATE_L4_SYSTEM')}` : `${t('CREATE_L4_SYSTEM')}`}
				<CustomEditableTooltip
					showIcon='faInfoCircle'
					text={l4AddEditInfo}
					moduleId={ICON_DESCRIPTION_ID.L4_ADD_EDIT}
				/>
			</h4>
			<div className='section-wrapper'>
				<div className='form-group'>
					<CustomInput
						className=''
						value={l4SystemName}
						label={t('L4SYSTEM_NAME')!!}
						onChange={(e: any) => onL4SystemChange(e)}
						name='l4System'
						placeholder={t('L4SYSTEM_NAME')}
						required
						type='text'
						isMandatory
						error={errorState.l4SystemName}
					/>
				</div>
				<div className='row'>
					<div className='col-xl-6 col-lg-6 col-md-12 col-sm-6'>
						<div className='form-group'>
							<CustomTextArea
								className=' two-row-height'
								value={description}
								onChange={(e: any) => onDescriptionChange(e)}
								label={t('DESCRIPTION')!!}
								placeholder={t('DESCRIPTION')!!}
								textAreaName='description'
								textAreaId='description'
								required
								cols={30}
								rows={5}
								isMandatory
								error={errorState.description}
							/>
						</div>
					</div>
					<div className='col-xl-6 col-lg-6 col-md-12 col-sm-6'>
						<div className='form-group'>
							<CustomTextArea
								className=' two-row-height'
								value={address}
								onChange={(e: any) => onAddressChange(e)}
								label={t('ADDRESS')!!}
								placeholder={t('ADDRESS')!!}
								textAreaName='address'
								textAreaId='address'
								required
								cols={30}
								rows={5}
								isMandatory
								error={errorState.address}
							/>
						</div>
					</div>
				</div>

				<div className='row'>
					<div className='col-lg-6 col-md-6 col-sm-6'>
						<div className='form-group'>
							<CustomDropDown
								popupSettings={{ popupClass: 'default-select-dropdown' }}
								isId
								className='form-control default-select-dropdown'
								dropdownValue={country}
								label={t('COUNTRY')!!}
								isMandatory
								handleDropDownChange={(e: any) => onCountryChange(e)}
								options={dropdownCountryValues}
								dataItemKey='encCountryId'
								dataTextField='countryName'
								loading={loading}
							/>
							{errorState?.country && errorState?.country !== '' && (
								<CustomError value={errorState?.country} />
							)}
						</div>
					</div>
					<div className='col-lg-6 col-md-6 col-sm-6'>
						<div className='form-group'>
							<CustomInput
								className=''
								value={l4Location}
								label={t('LOCATION')!!}
								onChange={(e: any) => onLocationChange(e)}
								name='location'
								placeholder={t('LOCATION')}
								required
								type='text'
								error={errorState.location}
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default CreateL4Config;
